// extracted by mini-css-extract-plugin
export default {"planTrip":"TripPlanInfo_planTrip__MeKtW","infoContainer":"TripPlanInfo_infoContainer__86WHO"};